import apiClient from '@/api/client';
import { getActiveHospitalId, getActiveClinicId } from '@/constants';

export const DEFAULT_CLINIC_FEATURES = {
  dashboardEnabled: true,
  patientsEnabled: true,
  appointmentsEnabled: true,
  consultationsEnabled: true,
  doctorsEnabled: true,
  reportsEnabled: false,
  paymentsEnabled: true,
};

export const featureService = {
  /**
   * GET /hospital/{hospitalId}/clinic/{clinicId}/features
   */
  getFeatures: async (clinicId, hospitalId) => {
    const activeHospId = getActiveHospitalId(hospitalId);
    const activeClinicId = getActiveClinicId(clinicId);

    try {
      const res = await apiClient.get(`/hospital/${activeHospId}/clinic/${activeClinicId}/features`);
      const data = res.data || res;
      return {
        ...DEFAULT_CLINIC_FEATURES,
        ...data,
      };
    } catch (err) {
      console.warn('Could not fetch clinic features from backend, using default/cached features:', err.message);
      // Fallback to localStorage if exists, else defaults
      const localKey = `pms_features_${activeClinicId}`;
      const saved = localStorage.getItem(localKey);
      if (saved) {
        try {
          return { ...DEFAULT_CLINIC_FEATURES, ...JSON.parse(saved) };
        } catch {
          // ignore
        }
      }
      return { ...DEFAULT_CLINIC_FEATURES };
    }
  },

  /**
   * PUT /hospital/{hospitalId}/clinic/{clinicId}/features
   */
  updateFeatures: async (clinicId, features, hospitalId) => {
    const activeHospId = getActiveHospitalId(hospitalId);
    const activeClinicId = getActiveClinicId(clinicId);

    // Always cache locally as fast resilient fallback
    const localKey = `pms_features_${activeClinicId}`;
    localStorage.setItem(localKey, JSON.stringify(features));

    try {
      const res = await apiClient.put(`/hospital/${activeHospId}/clinic/${activeClinicId}/features`, features);
      const data = res.data || res;
      return {
        ...DEFAULT_CLINIC_FEATURES,
        ...data,
      };
    } catch (err) {
      console.warn('Backend update failed, persisting locally:', err.message);
      return {
        ...DEFAULT_CLINIC_FEATURES,
        ...features,
      };
    }
  },
};

export default featureService;

